import { useOrganization } from 'hooks';

export default function useGustoCompanyId() {
  const { gustoCompanyId } = useOrganization();
  return gustoCompanyId ?? null;
}
